import {
  type McpConsentDecision,
  type McpConsentResult,
  McpConsentResultSchema,
  type McpConsentView,
  McpConsentViewSchema,
} from '@sbc/domain-models/agents';
import { useMutation, useQuery } from '@tanstack/react-query';

import { apiGet, apiSend } from './client';

const MCP_CONSENT_KEY = ['admin', 'mcp-consent'];

export function useMcpConsentRequest(requestId: string) {
  return useQuery<McpConsentView>({
    queryKey: [...MCP_CONSENT_KEY, requestId],
    queryFn: () =>
      apiGet(`/api/mcp/oauth/consent/${encodeURIComponent(requestId)}`, McpConsentViewSchema),
    // A pending request lives ten minutes and is single-use; refetching it after a
    // decision would 404 over a page that has already sent the browser onward.
    retry: false,
    staleTime: Infinity,
  });
}

export function useDecideMcpConsent() {
  return useMutation<McpConsentResult, Error, McpConsentDecision>({
    mutationFn: (input) => apiSend('POST', '/api/mcp/oauth/consent', input, McpConsentResultSchema),
  });
}
